import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CityDTO } from '../../shared/models/CityDTO';
import { CountyDTO } from '../../shared/models/CountyDTO';
import { AddressService } from '../../shared/services/address.service';
import { PlaceFilterForm } from '../models/PlaceFilterForm';
import { OperatorService } from '../services/operator.service';
import { Subscription } from 'rxjs';
import { OperatorPlaceDetails } from '../models/OperatorPlaceDetails';
import { Page } from '../../../shared/model/page';
import { NetworkContractFilterForm } from "../models/NetworkContractFilterForm";
import { NetworkContract } from "../models/NetworkContract";
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-gas-operator',
  templateUrl: './gas-operator.component.html',
  styleUrls: ['./gas-operator.component.scss']
})
export class GasOperatorComponent implements OnInit, OnDestroy {

  public placeForm: FormGroup;
  public networkContractForm: FormGroup;
  public placeFilterForm: PlaceFilterForm = new PlaceFilterForm();
  public networkContractFilterForm: NetworkContractFilterForm = new NetworkContractFilterForm();
  public gasConsumptionPlaces: Page<OperatorPlaceDetails>;
  public networkContracts: Page<NetworkContract>;
  public gasSuppliers = [];

  public counties: CountyDTO[] = [];
  public cities: CityDTO[] = [];

  paginationGasConsumptionPlaces = [];
  paginationNetworkContracts = [];

  private formSubscriptions: Subscription[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private operatorService: OperatorService,
    private addressService: AddressService,
    private toastrService: ToastrService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    this.placeForm = this.formBuilder.group({
      client: [''],
      code: [''],
      county: [''],
      city: [''],
    });
    this.formSubscriptions.push(
      this.placeForm.get('client').valueChanges.subscribe(value => this.placeFilterForm.client = value)
    );
    this.formSubscriptions.push(
      this.placeForm.get('code').valueChanges.subscribe(value => this.placeFilterForm.code = value)
    );
    this.formSubscriptions.push(
      this.placeForm.get('county').valueChanges.subscribe(value => {
        this.placeFilterForm.countyId = value;
        this.placeForm.get('city').setValue(0);
      })
    );
    this.formSubscriptions.push(
      this.placeForm.get('city').valueChanges.subscribe(value => this.placeFilterForm.cityId = value)
    );

    this.networkContractForm = this.formBuilder.group({
      client: [''],
      code: [''],
      contractType: [''],
      number: [''],
    });
    this.formSubscriptions.push(
      this.networkContractForm.get('client').valueChanges.subscribe(value => this.networkContractFilterForm.client = value)
    );
    this.formSubscriptions.push(
      this.networkContractForm.get('code').valueChanges.subscribe(value => this.networkContractFilterForm.code = value)
    );
    this.formSubscriptions.push(
      this.networkContractForm.get('number').valueChanges.subscribe(value => this.networkContractFilterForm.number = value)
    );
    this.formSubscriptions.push(
      this.networkContractForm.get('contractType').valueChanges.subscribe(value => this.networkContractFilterForm.contractType = value)
    );
  }

  ngOnInit(): void {
    this.addressService.getCounties().subscribe(data => this.counties = data);
    this.searchPlaces();
    this.operatorService.getOPGasSuppliers().subscribe(value =>
      this.gasSuppliers = value
    );
    this.searchNetworkContracts();
  }

  searchPlaces(offset?: number): void {
    this.placeFilterForm.pageOffset = offset;
    this.operatorService.getOPGasConsumptionPlaces(this.placeFilterForm).subscribe((val) => {
      console.log('getOPGasConsumptionPlaces_v2', val);
      this.gasConsumptionPlaces = val;
      this.placeFilterForm.pageOffset = val.number;
      this.paginationGasConsumptionPlaces = [{ pageNumber: val.number, className: 'page-item active' }];
      // this.paginationGasConsumptionPlaces.push({pageNumber: -1, className: 'page-item'});
      // for (let i = 1; i < val.totalPages; i++) {
      //   this.paginationGasConsumptionPlaces.push({pageNumber: i, className: 'page-item'});
      // }
      //this.paginationGasConsumptionPlaces[0].className = 'page-item active';
    });
  }

  searchNetworkContracts(offset?: number): void {
    this.networkContractFilterForm.pageOffset = offset;
    this.operatorService.getOPGasNetworkContracts(this.networkContractFilterForm).subscribe((networkContracts) => {
      this.networkContracts = networkContracts;
      this.networkContractFilterForm.pageOffset = networkContracts.number;
      this.paginationNetworkContracts = [{ pageNumber: networkContracts.number, className: 'page-item active' }];
      // for (let i = 1; i < val.totalPages; i++) {
      //   this.paginationNetworkContracts.push({ pageNumber: i, className: 'page-item' });
      // }
      // this.paginationNetworkContracts[this.networkContractFilterForm.pageOffset].className = 'page-item active';
    });
  }

  onChangeCounty(): void {
    this.cities = [];
    this.addressService.getCities(this.placeForm.get('county').value)
      .subscribe((cities: CityDTO[]) => this.cities = cities);
  }

  createConsumptionPlace(): void {
    this.router.navigate(['adaugare-loc-consum'], { relativeTo: this.route, state: { editable: true } });
  }

  createNetworkContract(): void {
    this.router.navigate(['adaugare-contract-de-retea'], { relativeTo: this.route, state: { editable: true } });
  }

  onCustomActionConsumptionPlace(event: any): void {
    switch (event.action) {
      case 'view':
        this.router.navigate(['detalii-loc-consum'], {
          relativeTo: this.route,
          state: { placeId: event.data.id, editable: false }
        });
        break;
      case 'edit':
        this.router.navigate(['editare-loc-consum'], {
          relativeTo: this.route,
          state: { placeId: event.data.id, editable: true }
        });
        break;
      case 'inactivate':
        this.operatorService.inactivateStatusConsumptionPlace(event.data.code).subscribe(() => {
          this.searchPlaces();
          this.toastrService.success('Loc de consum inactivat.');
        }
        );
        break;
    }
  }

  onCustomActionSuppliers(event: any): void {
    switch (event.action) {
      case 'impossibility':
        localStorage.setItem('operatorProjection', JSON.stringify(event.data));
        this.router.navigateByUrl('/operator/gaze-naturale/imposibilitate-furnizare');
        break;
      case 'removeImpossibility':
        this.operatorService.inactivateCancelSupplier(event.data.series).subscribe(() =>
          this.operatorService.getOPGasSuppliers().subscribe(value =>
            this.gasSuppliers = value
          )
        );
        break;
    }
  }

  onCustomActionNetworkContract(event: any): void {
    switch (event.action) {
      case 'viewNetworkContract':
        this.router.navigate(['detalii-contract-de-retea'], {
          relativeTo: this.route,
          state: { networkContractId: event.data.id, editable: false }
        });
        break;
    }
  }

  changePage(page: any): void {
    this.searchPlaces(page.pageNumber);
  }

  previousPage(): void {
    this.searchPlaces(this.placeFilterForm.pageOffset === 0 ? 0 : this.placeFilterForm.pageOffset - 1);
  }

  nextPage(): void {
    this.searchPlaces(this.placeFilterForm.pageOffset === this.gasConsumptionPlaces.totalPages - 1
      ? this.placeFilterForm.pageOffset : this.placeFilterForm.pageOffset + 1);
  }

  changeNetworkContractPage(page: any): void {
    let pageOffset = page.pageNumber;
    this.searchNetworkContracts(pageOffset);
  }

  previousNetworkContractPage(): void {
    let pageOffset = this.networkContractFilterForm.pageOffset === 0 ? 0 : this.networkContractFilterForm.pageOffset - 1;
    this.searchNetworkContracts(pageOffset);
  }

  nextNetworkContractPage(): void {
    let pageOffset = this.networkContractFilterForm.pageOffset === this.networkContracts.totalPages - 1
      ? this.networkContractFilterForm.pageOffset : this.networkContractFilterForm.pageOffset + 1;
    this.searchNetworkContracts(pageOffset);
  }

  public contractNetworkSettings = {
    actions: {
      custom: [
        {
          name: 'viewNetworkContract',
          title: '<p>Detalii</p>'
        }
      ],
      add: false,
      edit: false,
      delete: false,
      position: 'right',
      columnTitle: 'Opțiuni',
    },
    hideSubHeader: true,
    columns: {
      code: {
        title: 'CUI / CNP / Numar identificare',
      },
      name: {
        title: 'Client'
      },
      contractNumber: {
        title: 'Numar'
      },
      date: {
        title: 'Data contract',
        valuePrepareFunction: (value) => value ? new Date(value).toLocaleDateString('ro-RO') : '',
        filter: false
      },
      contractType: {
        title: 'Tip contract'
      }
    },
  };

  public supplierSettings = {
    actions: {
      custom: [
        {
          name: 'impossibility',
          title: '<p class="action-i">Imposibilitate furnizare</p>'
        },
        {
          name: 'removeImpossibility',
          title: '<p class="action-ri">Revoca imposibilitate furnizare</p>'
        }
      ],
      add: false,
      edit: false,
      delete: false,
      position: 'right',
      columnTitle: 'Opțiuni',
    },
    rowClassFunction: (row: any) => {
      let _class = '';
      if (row.data.status === 'ACTIV') {
        _class = 'row_ACTIVE ';
      } else if (row.data.status === 'SUSPENDAT') {
        _class = 'row_IMPOSSIBILITY ';
      } else if (row.data.status === 'IN CURS DE SUSPENDARE') {
        _class = 'row_IMPOSSIBILITY_PENDING ';
      } else {
        _class = 'row_DEFAULT ';
      }
      return _class;
    },
    hideSubHeader: true,
    columns: {
      code: {
        title: 'CUI'
      },
      supplier: {
        title: 'Furnizor'
      },
      status: {
        title: 'Status'
      }
    },
  };

  public consumptionPlaceSettings = {
    actions: {
      custom: [
        {
          name: 'view',
          title: '<p>Detalii</p>'
        },
        {
          name: 'edit',
          title: '<p>Editeaza</p>'
        },
        {
          name: 'inactivate',
          title: '<p class="action-hide">Inactiveaza</p>'
        },
      ],
      add: false,
      edit: false,
      delete: false,
      position: 'right',
      columnTitle: 'Opțiuni',
    },
    rowClassFunction: (row: any) => {
      if (row.data.status === 'INACTIV') {
        return 'row_INACTIVATE_HIDE';
      }
    },
    hideSubHeader: true,
    columns: {
      code: {
        title: 'CLC'
      },
      address: {
        title: 'Adresa'
      },
      status: {
        title: 'Status'
      }
    },
  };

  ngOnDestroy(): void {
    if (this.formSubscriptions) {
      for (const subscription of this.formSubscriptions) {
        if (subscription) {
          subscription.unsubscribe();
        }
      }
    }
  }

}
